import React from 'react';
import { COLORS } from '@/data';

interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit';
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  onClick,
  disabled,
  className = '',
  type = 'button'
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`flex items-center justify-center gap-2 text-zinc-900 px-5 py-3 rounded-xl font-semibold disabled:opacity-50 ${className}`}
    style={{ backgroundColor: COLORS.lime }}
  >
    {children}
  </button>
);
